import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import classes from './MyDegree.module.css';

const MyDegree = props => {
  const [nameLength, setNameLength] = useState(0);

  useEffect(() => {
    setNameLength(props.name.length + props.lastName.length);
  }, []);

  return (
    <div
      className={
        !props.demoProfile
          ? classes.contentSectionDiploma
          : classes.contentSectionDiplomaDemo
      }
    >
      <section className={classes.registerSection}>
        <Typography
          className={classes.diplomaText}
          variant="body2"
          gutterBottom
        >
          <strong>DIPLOMA</strong>
        </Typography>
        <div className={classes.contentDiploma}>
          <div className={classes.imageTitleContainer}>
            {(props.name !== '' || props.lastName !== '') &&
            nameLength > 28 ? (
              <Typography className={classes.titleImageShort}>
                {props.name} {props.lastName}
              </Typography>
            ) : (props.name !== '' || props.lastName !== '') &&
              nameLength <= 28 ? (
              <Typography className={classes.titleImage}>
                {props.name} {props.lastName}
              </Typography>
            ) : (
              <Typography className={classes.titleImageDefault}>
                Nombres Apellidos
              </Typography>
            )}
            <figure className={classes.degreeImgContainer}>
              <img
                className={classes.degreeImg}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/background-diploma-register.jpg"
                alt="Degree"
              />
            </figure>
          </div>
        </div>
        <Typography
          className={classes.diplomaSubtext}
          variant="body2"
          gutterBottom
        >
          Este es un ejemplo de cómo se verá tu diploma al finalizar
          cualquiera de tus cursos.
        </Typography>
        <Typography
          className={classes.diplomaSubtext}
          variant="body2"
          gutterBottom
        >
          <strong>
            Escribe correctamente tu nombre y apellido.
          </strong>
        </Typography>
      </section>
    </div>
  );
};

MyDegree.propTypes = {
  // eslint-disable-next-line react/require-default-props
  demoProfile: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  name: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  lastName: PropTypes.string
};

export default MyDegree;
